<template>
  <el-dialog
    :title="
      form.id ? $t('text.edit_manufacturer') : $t('text.add_manufacturer')
    "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="620px"
    @close="closeDialog()"
  >
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="90px">
        <el-form-item
          :label="$t('text.name') | firstLetterCapitalize"
          prop="name"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.address') | firstLetterCapitalize"
          prop="address"
        >
          <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.contact') | firstLetterCapitalize"
          prop="contact"
        >
          <el-input v-model="form.contact"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.active') | firstLetterCapitalize"
          prop="active"
        >
          <el-switch v-model="form.isEnabled"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        id: 0,
        name: '',
        address: '',
        contact: '',
        isEnabled: false
      },
      rules: this.initRules()
    }
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.rules = this.initRules()
    }
  },
  methods: {
    initRules() {
      return {
        name: [
          {
            required: true,
            message: this.$t('text.name_required')
          }
        ],
        address: [
          {
            required: true,
            message: this.$t('text.address_required')
          }
        ],
        contact: [
          {
            required: true,
            message: this.$t('text.contact_required')
          }
        ]
      }
    },
    openDialog() {
      this.dialogVisible = true
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    getParams() {
      return {
        ID: this.form.id,
        Name: this.form.name,
        Address: this.form.address,
        contact: this.form.contact,
        ManufacturerCode:
          this.form.manufacturerCode || Math.floor(Math.random() * 100),
        IsEnabled: this.form.isEnabled
      }
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.AddorUpdateManufacture(this.getParams())
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$parent.getData()
                this.closeDialog()
              } else {
                swal({
                  icon: 'error',
                  timer: 2000,
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    resetForm() {
      this.form = {
        id: 0,
        name: '',
        address: '',
        contact: '',
        isEnabled: false
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.subscription-code-info {
  margin-left: 125px;
  font-size: 13px;
  margin-top: -10px;
  margin-bottom: 20px;
}
</style>
